import React, { useState } from 'react';
import { projects } from '../data/portfolioData';
import { ExternalLink, Github, Eye, Folder, X } from 'lucide-react';

const Projects = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  const openProjectDetails = (project) => {
    setSelectedProject(project);
  };

  const closeProjectDetails = () => {
    setSelectedProject(null);
  };

  return (
    <section id="projects" className="py-5">
      <div className="container mx-auto px-6">
        <div className="text-center mb-8">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="text-primary">Mes projets</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">
            Quelques projets sur lesquels j'ai travaillé
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8">
          {projects.map((project) => (
            <div 
              key={project.id} 
              className="bg-gray-800/30 rounded-xl border border-gray-700 overflow-hidden hover:border-primary/50 transition-all duration-300 hover:transform hover:-translate-y-2 group"
            >
              {/* En-tête du projet */}
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center">
                    <Folder className="text-primary" size={24} />
                  </div>
                  <div className="flex gap-3">
                    {project.github && (
                      <a 
                        href={project.github} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="p-2 bg-gray-700 rounded-lg hover:bg-primary transition-colors"
                      >
                        <Github size={18} />
                      </a>
                    )}
                    {project.demo && (
                      <a 
                        href={project.demo} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="p-2 bg-gray-700 rounded-lg hover:bg-primary transition-colors"
                      >
                        <ExternalLink size={18} />
                      </a>
                    )}
                  </div>
                </div>
                
                <h3 className="text-xl font-bold mb-3">{project.title}</h3>
                <p className="text-gray-400 mb-6">{project.description}</p>
                
                {/* Technologies utilisées */}
                <div className="flex flex-wrap gap-2 mb-6">
                  {project.technologies.map((tech, idx) => (
                    <span 
                      key={idx} 
                      className="px-3 py-1 bg-gray-700/50 text-sm rounded-full text-gray-300"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
                
                {/* Bouton Voir plus */}
                <button 
                  onClick={() => openProjectDetails(project)}
                  className="w-full py-3 bg-gray-700/50 hover:bg-primary transition-colors rounded-lg flex items-center justify-center gap-2"
                >
                  <Eye size={18} />
                  Voir plus de détails
                </button>
              </div>
            </div>
          ))}
        </div>
        
        {/* Modal pour les détails du projet */}
        {selectedProject && (
          <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
            <div className="bg-gray-800 rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                <div className="flex justify-between items-start mb-6">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center">
                      <Folder className="text-primary" size={24} />
                    </div>
                    <h3 className="text-2xl font-bold">{selectedProject.title}</h3>
                  </div>
                  <button 
                    onClick={closeProjectDetails}
                    className="p-2 hover:bg-gray-700 rounded-lg transition-colors"
                  >
                    <X size={24} />
                  </button>
                </div>
                
                <p className="text-gray-300 mb-6">
                  {selectedProject.longDescription || selectedProject.description}
                </p>
                
                {/* Technologies utilisées */}
                <div className="mb-6">
                  <h4 className="text-lg font-bold mb-3">Technologies utilisées</h4>
                  <div className="flex flex-wrap gap-2">
                    {selectedProject.technologies.map((tech, idx) => (
                      <span 
                        key={idx} 
                        className="px-3 py-1 bg-primary/20 text-sm rounded-full text-primary"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>
                
                {/* Liens */}
                <div className="flex gap-4">
                  {selectedProject.github && (
                    <a 
                      href={selectedProject.github} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 px-4 py-2 bg-gray-700 hover:bg-primary rounded-lg transition-colors"
                    >
                      <Github size={18} />
                      Code source
                    </a>
                  )}
                  {selectedProject.demo && (
                    <a 
                      href={selectedProject.demo} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 px-4 py-2 bg-primary hover:bg-primary/80 rounded-lg transition-colors"
                    >
                      <ExternalLink size={18} />
                      Voir la démo
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Projects;